module.exports = __webpack_public_path__ + "media/xylophone.609a67fc.ogg";